require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-locations-san-juan-del-sur.json") })
        }
      }, "path---es-locations-san-juan-del-sur");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-locations-san-juan-del-sur!./.cache/json/es-locations-san-juan-del-sur.json
// module id = 1111
// module chunks = 231608221292675